'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./section.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = function Section(_ref, context) {
    var date = _ref.date,
        text = _ref.text;

    return _react2.default.createElement(
        'div',
        { className: 'sectionContainer' },
        _react2.default.createElement(
            'div',
            { className: 'sectionContainer__date' },
            _react2.default.createElement('img', { className: 'sectionContainer__date__img', src: context.baseUrl + '/media/image/instructions/circles.svg' }),
            _react2.default.createElement(
                'p',
                { className: 'sectionContainer__date__text' },
                date
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'sectionContainer__text' },
            text
        )
    );
};

Section.contextTypes = {
    baseUrl: _propTypes2.default.string.isRequired
};

exports.default = Section;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructions/Section/Section.js
// module id = 699
// module chunks = 0